import { createContext, useContext, useEffect, useState } from "react";

const CompanyCtx = createContext(null);

export function CompanyProvider({ children }) {
  const [company, setCompany] = useState(() => localStorage.getItem("autotrans_company") || "all");
  useEffect(() => { localStorage.setItem("autotrans_company", company); }, [company]);
  return <CompanyCtx.Provider value={{ company, setCompany }}>{children}</CompanyCtx.Provider>;
}

export const useCompany = () => useContext(CompanyCtx);
